import { Route, HashRouter as Router, Routes } from "react-router-dom";
import Admin from "./components/Admin";
import Approval from "./components/Approval";
import Cashier from "./components/Cashier";
import Chef from "./components/Chef";
import Home from "./components/Home";
import Homepage from "./components/Homepage";
import Printing from "./components/Printing";

function App() {
  return (
    <Router>
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route path="/" element={<Homepage />} />
        <Route path="/home" element={<Home />} />
        <Route path="/chef" element={<Chef />} />

        {/* CASHIER ROUTES */}
        <Route path="/cashier" element={<Cashier />} />
        <Route path="/cashier/approval" element={<Approval />} />
        <Route path="/cashier/print" element={<Printing />} />

        {/* ADMIN ROUTES */}
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/orders" element={<Admin />} />
        <Route path="/admin/purchases" element={<Admin />} />
        <Route path="/admin/payments" element={<Admin />} />
        <Route path="/admin/expenses" element={<Admin />} />
        <Route path="/admin/menu" element={<Admin />} />

        {/* EMPLOYEE ROUTE */}
        <Route path="/admin/employees" element={<Admin />} />

        {/* ACTUAL BALANCE ROUTE */}
        <Route path="/admin/actual-balance" element={<Admin />} />

        {/* SPECIAL ORDER ROUTE - ADD THIS */}
        <Route path="/admin/special-order" element={<Admin />} />

        {/* REPORT ROUTES */}
        <Route path="/admin/reports/sales" element={<Admin />} />
        <Route path="/admin/reports/performance" element={<Admin />} />
        <Route path="/admin/reports/cash" element={<Admin />} />
        <Route path="/admin/reports/revenue" element={<Admin />} />
      </Routes>
    </Router>
  );
}

export default App;